import { IconButton } from './IconButton';
import { IconSadFace } from './QuirkIcons';

interface NoResultsProps {
	heading?: string;
	subheading?: string;
	icon?: JSX.Element;
	compact?: boolean;
	children?: JSX.Element;
	testId?: string;
}

export const NoResults = ({ heading, subheading, icon, compact, children, testId }: NoResultsProps) => {
	const innerContent = (
		<div className="center-align" data-testid={testId}>
			<div className="space20" />
			<IconButton icon={icon || <IconSadFace />} className="icon-graphic" />
			<div className="space20" />
			<h4>{heading || 'No results.'}</h4>
			{subheading && <p>{subheading}</p>}
			{children}
		</div>
	);

	return <>{compact ? innerContent : <div>{innerContent}</div>}</>;
};
